import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { useCanvasStore } from "@/lib/stores/canvas-store/canvas-store";
import { ElementTypographyDto, SceneTypeDto } from "@repo/api/overlays";
import { FontSelect } from "./FontSelect";

type Props = {
  element: {
    externalId: string;
    typography: ElementTypographyDto;
  };
  sceneType: SceneTypeDto;
};

export default function ElementFontSection({ element }: Props) {
  const draftFontSize = useCanvasStore(
    (state) => state.drafts[element.externalId]?.fontSize,
  );
  const updateElement = useEditorStore((state) => state.service.updateElement);
  const rememberTextTypography = useEditorStore(
    (state) => state.service.rememberTextTypography,
  );

  const withTypography = (fn: (typography: ElementTypographyDto) => void) => {
    updateElement(element.externalId, (updatedElement) => {
      if (!("typography" in updatedElement)) {
        throw new Error("Typography is not in element");
      }

      fn(updatedElement.typography);
      rememberTextTypography(updatedElement.typography);
    });
  };

  return (
    <FontSelect
      fontExternalId={element.typography.fontExternalId}
      fontWeight={element.typography.fontWeight}
      fontStyle={element.typography.fontStyle}
      fontSize={draftFontSize ?? element.typography.fontSize}
      onSelectFont={({ font, fontWeight, fontStyle }) =>
        withTypography((typography) => {
          typography.fontExternalId = font.externalId;
          typography.fontWeight = fontWeight;
          typography.fontStyle = fontStyle;
        })
      }
      onFontWeightChange={(fontWeight) =>
        withTypography((typography) => {
          typography.fontWeight = fontWeight;
        })
      }
      onFontStyleChange={(fontStyle) =>
        withTypography((typography) => {
          typography.fontStyle = fontStyle;
        })
      }
      onFontSizeChange={(fontSize) =>
        withTypography((typography) => {
          typography.fontSize = fontSize;
        })
      }
    />
  );
}
